<template>
  <div>
    <div v-if="showOne" class="AllDiv">
      <div class="JointTexts">
        <p>SHOP BY STORE</p>
        <h1>{{$t('data.headText.entity.title')}}</h1>
        <p class="JointTextsp">VVC Physical store</p>
      </div>
      <div>
        <div class="jointAllS">
          <div class="jointAll" v-for="(item,index) in msgAll"  :key="index">
            <div class="jointall_img">
              <img :src="item.img[0]"/>
            </div>
            <div class="jointText">
              <div>{{item.title}}</div>
              <div>{{item.address_name}}</div>
              <div>
                <p>{{item.address}}</p>
                <p>{{item.email}}</p>
              </div>
              <div><a href=" javascript:void(0)" @click="moerAdd(index)">查看更多细节</a></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showTwo">
      <div class="AllDivs">
        <div class="Shops">
          <div class="OutImg"><img @click="outmoer()" src="../assets/timg.jpg" height="40px" width="40px"/></div>
          <p>SHOP BY STORE</p>
          <div class="ShopsText">{{msgMoer.address_name}}</div>
          <div class="ShopsTexts">VVC OUTLETS</div>
          <div class="imgall">
            <div  v-for="(box,index,i) in msgMoer.img" :key="i">
                <img :src="box" />
            </div>
            <!-- <img src="../assets/shiti.jpg" alt=""> -->
          </div>
        </div>
        <div class="address">
          <div class="addressText">
            <p>地址</p>
            <div>{{msgMoer.address}}, {{msgMoer.title}} Email: {{msgMoer.email}} Tel: {{msgMoer.phone}}
            </div>
          </div>
          <div>
            <div>
              <baidu-map v-bind:style="mapStyle" class="bm-view" ak="你的百度地图ak" :center="center" :zoom="zoom" :scroll-wheel-zoom="true"
                         @click="getClickInfo" @moving="syncCenterAndZoom" @moveend="syncCenterAndZoom" @zoomend="syncCenterAndZoom">
                <bm-view style="width: 100%; height:350px;"></bm-view>
                <bm-marker :position="{lng: center.lng, lat: center.lat}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
                </bm-marker>
                <bm-control :offset="{width: '10px', height: '10px'}">
                  <bm-auto-complete v-model="keyword" :sugStyle="{zIndex: 999999}">
                    <input type="text" placeholder="请输入搜索关键字"  class="serachinput">
                  </bm-auto-complete>
                </bm-control>
                <bm-local-search :keyword="keyword" :auto-viewport="true" style="width:0px;height:0px;overflow: hidden;"></bm-local-search>
              </baidu-map>
            </div>
          </div>
        </div>

      </div>

    </div>
     <div class="pageAll" v-if="pagebool">
        <span class="SpanClick" v-for="(item , index) in mun" :key="index" :style='item==spanid ? "background:#9B9B9B;color:#fff":""'  @click="listVideo(item)">{{item}}</span>
      </div>
  </div>
</template>

<script>
  import {BaiduMap, BmControl, BmView, BmAutoComplete, BmLocalSearch, BmMarker} from 'vue-baidu-map'
  export default {
    components: {
      BaiduMap,
      BmControl,
      BmView,
      BmAutoComplete,
      BmLocalSearch,
      BmMarker
    },
    name: "joint",
    data() {
      return {
        showOne: true,
        showTwo: false,
        msgAll: [],
        msgMoer : {},
        showMapComponent: this.value,
        keyword: '',
        mapStyle: {
          width: '100%',
          height: this.mapHeight + 'px'
        },
        center: {lng: 0, lat: 0},
        zoom: 15,
        mun:'',
        nums:'',
        fenye:'',
        spanid:1,
        pagebool:true
      }
    },
    watch: {
      value: function (currentValue) {
        this.showMapComponent = currentValue
        if (currentValue) {
          this.keyword = ''
        }
      }
    },
    methods: {
      getClickInfo (e) {
        this.center.lng = e.point.lng
        // console.log(this.center.lng);
        this.center.lat = e.point.lat
        // console.log(this.center.lat);
      },
      syncCenterAndZoom (e) {
        const {lng, lat} = e.target.getCenter()
        this.center.lng = lng
        this.center.lat = lat
        this.zoom = e.target.getZoom()
      },
       listVideo(a) {
        this.num=a
        this.req.post('http://jd1.vvc.tw/index/index/getAddress', this.qs.stringify({
          pages: this.num,
          mums: '12'
        })).then((res) => {
          // this.allVideo = res.data.data
          // console.log(this.allVideo);
          this.spanid=a
        }).catch((err) => {
          console.log(err);
        })
        console.log(a);
      },
      ShowMsg() {
        this.req.post('http://jd1.vvc.tw/index/index/getAddress').then((res) => {
          if (res.data.code == 1) {
            this.msgAll = res.data.data.list

            for(let i=0;i<this.msgAll.length;i++){

              this.msgAll[i].img=JSON.parse(this.msgAll?this.msgAll[i].img:null)

              this.mun = Math.ceil((this.msgAll.length) / 4)

              console.log(this.mun)
            }
            // console.log(res.data);
          }
        })
      },
      moerAdd(i) {
        // console.log(this.msgAll[i]);
        this.msgMoer = this.msgAll[i]
        this.showOne = ! this.showOne
        this.showTwo = ! this.showTwo
        // console.log(this.center.lng);
        this.center.lng =  parseInt(this.msgMoer.detail.split(',')[0])
        this.center.lat =  parseInt(this.msgMoer.detail.split(',')[1])
        this.pagebool=false
        // console.log(this.center.lng + 'zheli');
        // console.log(this.center.lat + 'zheli');
      },
      outmoer(){
        this.showOne = ! this.showOne
        this.showTwo = ! this.showTwo
        this.pagebool=true
      }
    },
    created() {
      this.ShowMsg()
    }
  }
</script>

<style scoped lang="stylus">
  .AllDiv
    width 1920px
    margin 0 auto
    padding-top 86px
    padding-bottom 143px
  .JointTexts
    text-align center
    p
      &:nth-child(1)
        margin-top 91px
        font-size: 12px;
        font-family: SFUIText-Light;
        font-weight: 300;
        color: rgba(74, 74, 74, 1);
  .serachinput {
    width: 300px;
    box-sizing: border-box;
    padding: 9px;
    border: 1px solid #dddee1;
    line-height: 20px;
    font-size: 16px;
    height: 38px;
    color: #333;
    position: relative;
    border-radius: 4px;
    -webkit-box-shadow: #666 0px 0px 10px;
    -moz-box-shadow: #666 0px 0px 10px;
    box-shadow: #666 0px 0px 10px;
  }
    .JointTextsp
      margin-top 12px
      font-size: 16px;
      font-family: SFUIText-Light;
      font-weight: 300;
      color: rgba(155, 155, 155, 1);

    h1
      margin-top 12px
      font-size: 32px;
      font-family: PingFang-SC-Bold;
      font-weight: bold;
      color: rgba(74, 74, 74, 1);
      letter-spacing: 1px;

  .jointAll
    width 566px
    margin 54px 34px 54px 34px
  .jointall_img
    width 566px
    height 425px
    overflow hidden
    display flex
    align-items center
    background #e2e2ee
    img
      width 566px
      height auto
  .jointText
    background: rgba(246, 246, 246, 1);
    text-align center
    a
      font-size: 14px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: rgba(74, 74, 74, 1);
    div
      &:nth-child(1)
        font-size: 14px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(74, 74, 74, 1);
        padding-top 32px
      &:nth-child(2)
        font-size 17px
        color rgba(74, 74, 74, 1)
        font-weight: 600;
        font-family: PingFangSC-Semibold
        padding-top 40px
      &:nth-child(3)
        color: rgba(155, 155, 155, 1)
        font-size: 14px;
        font-family: PingFangSC-Semibold;
        font-weight: 500;
        padding-top 40px
        padding-bottom 40px
      &:nth-child(4)
        padding-bottom 26px

  .jointAllS
    display flex
    margin 0 auto
    width 556px + 556px + 200px
    flex-wrap wrap

  .AllDivs
    width 1920px
    margin 0 auto

  .Shops
    padding-top 86px + 91px
    text-align center
    p
      font-size: 12px;
      font-family: SFUIText-Light;
      font-weight: 300;
      color: rgba(74, 74, 74, 1);
      margin-bottom 12px
    .ShopsText
      font-size: 32px;
      font-family: PingFang-SC-Bold;
      font-weight: bold;
      color: rgba(74, 74, 74, 1);
      line-height: 45px;
      letter-spacing: 1px
      margin-bottom 15px
    .ShopsTexts
      font-size: 12px;
      font-family: SFUIText-Light;
      font-weight: 300;
      color: rgba(74, 74, 74, 1);
      margin-bottom 47px

  .address
    text-align center

  .addressText
    p
      font-family: PingFangSC-Semibold;
      color rgba(74, 74, 74, 1)
      font-weight: 700;
      margin-top 95px
      margin-bottom 15px
    div
      margin 0 auto
      width: 338px;
      height: 139px;
      font-size: 16px;
      font-family: SFUIText-Light;
      font-weight: 300;
      color: rgba(155, 155, 155, 1);
.OutImg
  text-align left
  width 1200px
  margin 0 auto
.imgall
  width 1236px
  display flex
  margin 0 auto
  // justify-content
  div
    width 33%
    height 800px
    overflow hidden
    display flex
    justify-content center
    img
      height  100%
  div:nth-of-type(2)
    margin 0 20px
 .pageAll
    text-align center
    span
      display inline-block
      width: 32px;
      height: 32px;
      background: rgba(220, 221, 221, 1);
      font-size: 16px;
      font-family: SFUIText-Regular;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height 32px
      text-align center
  .SpanClick
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer
    margin-right 20px


</style>



// WEBPACK FOOTER //
// src/components/joint.vue